import React,{useState, useEffect, useRef} from 'react';
import { useSearchParams, useNavigate } from "react-router-dom";
import { HiArrowLeft } from "react-icons/hi2";
import {FaCamera} from "react-icons/fa";
import { Navbar, Button } from 'flowbite-react';
import NicFront from "../img/nic-front.png";
import NicBack from "../img/nic-back.png"
import axios from "axios";
import { ONBOARDING_API_ENDPOINT } from "../config/url.config";
import "./styles.css"
import { MdCheckCircle } from "react-icons/md";
import { BsThreeDots } from "react-icons/bs";
import { documentsWasUpdatedByUser } from "../utils/updatedByUser"
import { navigateToSessionExpired } from "../utils/sessionExpired";
import { getAuthHeader } from "../utils/superFetch";

const DrivingLicense = (props) => {
  const cssForImageCard = {
    success : {
      imageDiv: 'mt-2 mb-10 custom-card-success border rounded-md items-center shadow-none p-10',
    },
    standard : {
      imageDiv: 'mt-2 mb-10 custom-card border rounded-md items-center shadow-none p-10',
    }
  }
  
  const selectedProfileType = JSON.parse(sessionStorage.getItem("selectedProfileType"));

  let [frontDrivingLicense, setFrontDrivingLicense] = useState();
  let [backDrivingLicense, setBackDrivingLicense] = useState();
  let frontDrivingLicenseRef = useRef();
  let backDrivingLicenseRef = useRef();
  let [validationFront, setValidationFront] = useState({ show: false , message: "", class:""});
  let [validationBack, setValidationBack] = useState({ show: false , message: "", class:""});

  let [userUploadedFrontLicense, setUserUploadedFrontLicense] = useState(false)
  let [userUploadedBackLicense, setUserUploadedBackLicense] = useState(false)
  let [frontLicenseUploading, setFrontLicenseUploading] = useState(false)
  let [backLicenseUploading, setBackLicenseUploading] = useState(false)
  let [validationOnSubmit, setValidationOnSubmit] = useState(false)

  const navigate = useNavigate();

  const handleFrontDLClick = () => {
    // 👇️ open file input box on click of other element
    frontDrivingLicenseRef.current.click();
  };
  const handleBackDLClick = () => {
    // 👇️ open file input box on click of other element
    backDrivingLicenseRef.current.click();
  };

  useEffect(()=>{
    
    if(props.memberRequirement && props.memberRequirement.requiredDocuments[props.itemIndex].requiredItems[0].url) {
      setFrontDrivingLicense(props.memberRequirement && props.memberRequirement.requiredDocuments[props.itemIndex].requiredItems[0].url)
      setUserUploadedFrontLicense(true)
    } else {
      setFrontDrivingLicense(NicFront)
    }
    if(props.memberRequirement && props.memberRequirement.requiredDocuments[props.itemIndex].requiredItems[1].url) {
      setBackDrivingLicense(props.memberRequirement && props.memberRequirement.requiredDocuments[props.itemIndex].requiredItems[1].url)
      setUserUploadedBackLicense(true)
    } else {
      setBackDrivingLicense(NicBack)
    }
    
    
  }, [])

  const handleFileChange = async (e, itemName) => {
    let file = e.target.files[0]
    if (!["image/png", "image/jpeg", "image/jpg"].includes(file.type) || file.size/1000000 > 7 ) {
      if (itemName === "backSide"){
        setValidationBack({ show: true , message: "Invalid image. Only images of type png, jpg, jpeg with size below 7mb can be uploaded", class:"error-msg"})
      } else {
        setValidationFront({ show: true , message: "Invalid image. Only images of type png, jpg, jpeg with size below 7mb can be uploaded", class:"error-msg"})
      }
      return
    }
    if (itemName === "backSide") {
      setBackLicenseUploading(true)
    } else {
      setFrontLicenseUploading(true)
    }
    const formData = new FormData();
    formData.append('file', file);
    formData.append("inputType", "image");
    formData.append("itemName", itemName);
    formData.append("item", "drivingLicense");
    const config = {
      headers: { "content-type": "multipart/form-data", "upload-document": true , ...getAuthHeader() },
    };
    try {
      const res = await axios.post(
        `${ONBOARDING_API_ENDPOINT}/api/onboarding/updateConfiguration?profileType=${selectedProfileType.profileId}`,
        formData,
        config
      );
      if (itemName === "backSide"){
        // setBackDrivingLicense(res.data.result.url)
        setBackDrivingLicense(URL.createObjectURL(file))
        setValidationBack({ show: false , message: "", class:""})
        setUserUploadedBackLicense(true)
      } else {
        // setFrontDrivingLicense(res.data.result.url)
        setFrontDrivingLicense(URL.createObjectURL(file))
        setValidationFront({ show: false , message: "", class:""})
        setUserUploadedFrontLicense(true)
      }

      let tmpData = {...props.memberRequirement}
      for (let i = 0 ; i< tmpData.requiredDocuments[props.itemIndex].requiredItems.length ;i++) {
        if (
          itemName === tmpData.requiredDocuments[props.itemIndex].requiredItems[i].itemName
        ) {
          if(tmpData.requiredDocuments[props.itemIndex].requiredItems[i].status === 2 || tmpData.requiredDocuments[props.itemIndex].requiredItems[i].value !== '') {
            documentsWasUpdatedByUser(`${tmpData.requiredDocuments[props.itemIndex].item}`)
          }
          tmpData.requiredDocuments[props.itemIndex].requiredItems[i].value = res.data.result.itemValue

          
          break
        }
      }
      props.setMemberRequirement(tmpData)
      setFrontLicenseUploading(false)
      setBackLicenseUploading(false)
    } catch (err) {
      navigateToSessionExpired(navigate, {
        reason: "driving_license_upload_failed",
        source: "handleFileChange",
        component: "DrivingLicense",
        endpoint: `${ONBOARDING_API_ENDPOINT}/api/onboarding/updateConfiguration?profileType=${selectedProfileType.profileId}`,
        status: err?.response?.status,
        message: err?.message,
        item: "drivingLicense",
        itemName,
      })
    }
  }

  return (
    <>
    <Navbar
        fluid={true}
        rounded={true}
        className='shadow mb-3' style={{position:'fixed', width:'100%', top:'0'}}>
          
            <Navbar.Brand onClick={()=>{props.setOpenUploadDocument({openDocument : false , documentType : ""})}}>
              <HiArrowLeft className='h-10 w-5 ml-2' />
            </Navbar.Brand>
          
        
      </Navbar>
    <div className='p-6 max-w-md m-auto' style={{paddingTop:'80px'}}>
        <h5 className="text-2xl mb-2 font-bold tracking-tight text-gray-900 dark:text-white">
          Driving License
        </h5>
        <p className='mb-8 text-gray-600'>Below are the required document to setup Rydesend account.</p>
        { validationOnSubmit && 
          <div className="error-msg">
            <span>Need to Upload both the sides of the Driving License before submitting for verification</span>
          </div>
        }
        {
          userUploadedFrontLicense && 
          <div class="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white" style={{paddingRight: '10px'}}>
            <MdCheckCircle style = {{ color: '#15BE44' }}/>
          </div>
        }
        <label className='font-bold tracking-tight text-gray-900'>Front Side</label>
        <div className={ userUploadedFrontLicense ?  cssForImageCard.success.imageDiv : cssForImageCard.standard.imageDiv } >
        { validationFront.show &&
                  
                  <div className={ validationFront.class}>
                      <span >{validationFront.message}</span>
                  </div>
              
              }
          <img src={frontDrivingLicense}
            className="w-auto m-auto"
            alt="Ryde" />
            <p className='text-xs text-gray-400 tracking-tight mt-2'><i>Ensure photo is clear with all four sides visible.</i></p>
            
            <Button  pill={true} className='mt-5 m-auto w-sm pr-4' onClick={handleFrontDLClick}>
            
            {
              frontLicenseUploading ? <BsThreeDots className="h-5 w-10" /> : <FaCamera className="h-5 w-10" />
            }
            <label
                // for="file-upload"
                class="relative cursor-pointer rounded-md font-medium"
              >
                <span>{frontLicenseUploading ? 'Saving' : userUploadedFrontLicense ? 'Replace' : 'Upload' }</span>
                
               {/* <input
                  id="file-upload"
                  name="file-upload"
                  type="file"
                  class="sr-only"
                  onChange={async (event)=>{ await handleFileChange(event, "frontSide" ) }}
                />  */}
                 
              </label>
             
          </Button>
          <input
                  id="file-upload"
                  name="file-upload"
                  type="file"
                  // class="sr-only"
                  style={{display: 'none', width:'0px',}}
                  ref={frontDrivingLicenseRef}
                  onChange={async (event)=>{ await handleFileChange(event, "frontSide" ) }}
                /> 
          
        </div>
        {
          userUploadedBackLicense && 
          <div class="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white" style={{paddingRight: '10px'}}>
            <MdCheckCircle style = {{ color: '#15BE44' }}/>
          </div>
        }
        <label className='font-bold tracking-tight text-gray-900'>Back Side</label>
        <div className={ userUploadedBackLicense ?  cssForImageCard.success.imageDiv : cssForImageCard.standard.imageDiv}>
        { validationBack.show &&
                  
                  <div className={ validationBack.class}>
                      <span >{validationBack.message}</span>
                  </div>
              
              }
                <img src={backDrivingLicense}
            className="w-auto m-auto"
            alt="Ryde" />
            <p className='text-xs text-gray-400 tracking-tight mt-2'><i>Ensure photo is clear with all four sides visible.</i></p>
            
            <Button  pill={true} className='mt-5 m-auto w-sm pr-4' onClick={handleBackDLClick}>
            
            {
              backLicenseUploading ? <BsThreeDots className="h-5 w-10" /> : <FaCamera className="h-5 w-10" />
            }
            <label
                // for="file-upload-backside"
                class="relative cursor-pointer rounded-md font-medium"
              >
                <span>{backLicenseUploading ? 'Saving' : userUploadedBackLicense ? 'Replace' : 'Upload' }</span>
                
               {/* <input
                  id="file-upload-backside"
                  name="file-upload"
                  type="file"
                  class="sr-only"
                  onChange={async (event)=>{await handleFileChange(event, "backSide" )}}
                />  */}
                 
              </label>
             
          </Button>
          <input
                  id="file-upload-backside"
                  name="file-upload"
                  type="file"
                  // class="sr-only"
                  style={{display: 'none', width:'0px',}}
                  ref={backDrivingLicenseRef}
                  onChange={async (event)=>{await handleFileChange(event, "backSide" )}}
                /> 
          
        </div>
        <Button className='bg-primary w-full mt-5' pill={true} disabled={false} onClick={()=>{
          if(userUploadedFrontLicense && userUploadedBackLicense ) {
            props.setOpenUploadDocument({
              openDocument: false,
              documentType: "",
            });
          } else {
            setValidationOnSubmit(true)
            window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
          }
        }}>
                    Save
                  </Button>
    </div>
   
    </>
  )
}

export default DrivingLicense;